import { useTranslation } from 'react-i18next';
import { ParcelItem } from '../../../models/hsCode';
import {
  FontSizes,
  TextBody,
  TextLabel,
} from '../../../common/typography/typography.styles';
import { getFormattedPrice } from '../../../utils/price/get-formatted-price';
import { getAdditionalFieldTransKey } from '../../parcel-creation/parcel-items-management/configs/additional-fields.config';
import {
  ParcelContentTitle,
  SubSection,
  SubSectionList,
  SubSectionRow,
} from './details-sidebar.styles';

interface Props {
  item: ParcelItem;
  currencySymbol: string;
}

const ShipmentItemInfo = ({ item, currencySymbol }: Props) => {
  const { t } = useTranslation();

  return (
    <SubSection>
      <ParcelContentTitle>{item.description_standart}</ParcelContentTitle>
      {item.description_free && (
        <p className='item-description'>{item.description_free}</p>
      )}
      <SubSectionList>
        <SubSectionRow>
          <TextLabel
            as='p'
            $fontSize={FontSizes.small}>
            {t('quantity')}
          </TextLabel>
          <TextBody>{item.number_of_items}</TextBody>
        </SubSectionRow>
        <SubSectionRow>
          <TextLabel
            as='p'
            $fontSize={FontSizes.small}>
            {t('conditions')}
          </TextLabel>
          <TextBody>{t(item.is_new === false ? 'used' : 'new')}</TextBody>
        </SubSectionRow>
        <SubSectionRow>
          <TextLabel
            as='p'
            $fontSize={FontSizes.small}>
            {t('declared_value')}
          </TextLabel>
          <TextBody>{getFormattedPrice(item.value, currencySymbol)}</TextBody>
        </SubSectionRow>
        {item.additional_fields &&
          Object.entries(item.additional_fields)
            .filter(([, fieldValue]) => !!fieldValue?.at(0))
            .map(([fieldName, fieldValue]) => (
              <SubSectionRow key={fieldName}>
                <TextLabel
                  as='p'
                  $fontSize={FontSizes.small}>
                  {t(getAdditionalFieldTransKey(fieldName))}
                </TextLabel>
                <TextBody>{fieldValue.at(0)}</TextBody>
              </SubSectionRow>
            ))}
      </SubSectionList>
    </SubSection>
  );
};

export default ShipmentItemInfo;
